<template>
  <component
    :is="name"
    class="watermark absolute inset-0 pointer-events-none"
    :style="{ opacity }"
  />
</template>

<script>
import WhitelabelLight from '@/assets/svg/watermarks/whitelabel-light.svg?inline'
import WatermarkLight from '@/assets/svg/watermarks/watermark-light.svg?inline'
import WhitelabelDark from '@/assets/svg/watermarks/whitelabel-dark.svg?inline'
import WatermarkDark from '@/assets/svg/watermarks/watermark-dark.svg?inline'
import { contrast } from '@/lib/helpers/colors'
import { mapGetters } from 'vuex'

export default {
  components: {
    WhitelabelLight,
    WatermarkLight,
    WhitelabelDark,
    WatermarkDark,
  },

  props: {
    background: { type: String, default: null },
  },

  computed: {
    /*
     * Calculate if the background is light or dark.
     *
     * @returns {'light' | 'dark'}
     */
    theme() {
      return contrast(this.background)
    },

    /*
     * Build the watermark SVG name based on whitelabel & the colour of the logo.
     *
     * @returns {'watermark-light' | 'watermark-dark'}
     */
    name() {
      return `${this.isUs ? 'watermark' : 'whitelabel'}-${this.theme}`
    },

    /*
     * Lighter backgrounds require a slightly more opaque
     * watermark to not obscure the logo.
     */
    opacity() {
      return this.theme === 'light' ? '0.02' : '0.02'
    },

    ...mapGetters(['isUs']),
  },
}
</script>
